import React, { useEffect, useState } from "react";
import axios from "axios";
import cs from "../CallSetting/CallSetting.module.css";
import { API_BASE_URL } from "../../Store/apiStore";

// Same defaults the Python service falls back to (transfer_voicemail.py).
export const VM_DEFAULTS = {
    static:
        "Hi {{lead_first_name}}, this is {{agent_name}} from {{business_name}}. Sorry we missed you. We were calling about your enquiry. Please give us a call back at this number when you get a chance. Thanks!",
    prompt:
        "Leave a short, friendly voicemail for the lead: say who you are and which business you are from, that you were following up on their enquiry, and ask them to call back.",
};
export const DEFAULT_VOICEMAIL = { action: "hangup", mode: "static", text: VM_DEFAULTS.static };
const VARIABLES = ["lead_first_name", "lead_name", "lead_inquiry", "agent_name", "business_name"];

// What happens when a lead's voicemail answers — Python agents only (a Retell
// agent's voicemail is Retell's). Controlled: saved with the page's Save button.
const PounceVoicemail = ({ agentId, value, onChange, className, style }) => {
    const [isPython, setIsPython] = useState(false);
    const vm = value || DEFAULT_VOICEMAIL;

    useEffect(() => {
        if (!agentId) return;
        axios
            .get(`${API_BASE_URL}/agent/getAgent/${agentId}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` },
            })
            .then((res) => setIsPython(String(res.data?.agentCreationType || "").toLowerCase() === "python"))
            .catch((err) => console.error("Error fetching agent details:", err));
    }, [agentId]);

    if (!isPython) return null;

    const chooseMode = (mode) => {
        if (mode === vm.mode) return;
        // Swap in the other default unless the owner wrote their own text.
        const keep = vm.text.trim() && vm.text !== VM_DEFAULTS[vm.mode];
        onChange({ ...vm, mode, text: keep ? vm.text : VM_DEFAULTS[mode] });
    };

    return (
        <div className={className} style={style}>
            <div className={cs.toggleRow}>
                <label className={cs.label}>Voicemail</label>
            </div>
            <p className={cs.description}>What the agent does when a lead's voicemail picks up.</p>
            <div className={cs.vmBox}>
                <p className={cs.vmTitle}>Voicemail Response</p>
                <label className={cs.vmRadio}>
                    <input
                        type="radio"
                        name="pounceVmAction"
                        checked={vm.action !== "message"}
                        onChange={() => onChange({ ...vm, action: "hangup" })}
                    />
                    <span>Hang up if reaching voicemail</span>
                </label>
                <label className={cs.vmRadio}>
                    <input
                        type="radio"
                        name="pounceVmAction"
                        checked={vm.action === "message"}
                        onChange={() => onChange({ ...vm, action: "message" })}
                    />
                    <span>Leave a message if reaching voicemail</span>
                </label>

                {vm.action === "message" && (
                    <>
                        <div className={cs.vmTabs}>
                            {[
                                ["prompt", "Prompt"],
                                ["static", "Static Sentence"],
                            ].map(([mode, label]) => (
                                <button
                                    key={mode}
                                    type="button"
                                    className={`${cs.vmTab} ${vm.mode === mode ? cs.vmTabActive : ""}`}
                                    onClick={() => chooseMode(mode)}
                                >
                                    {label}
                                </button>
                            ))}
                        </div>
                        <textarea
                            className={cs.vmText}
                            rows={4}
                            maxLength={1000}
                            value={vm.text}
                            onChange={(e) => onChange({ ...vm, text: e.target.value })}
                        />
                        <p className={cs.vmHint}>
                            {vm.mode === "prompt"
                                ? "The agent writes the message from this instruction, in its own voice."
                                : "Spoken after the beep, in the agent's voice. Variables: " +
                                  VARIABLES.map((v) => `{{${v}}}`).join(", ")}
                        </p>
                    </>
                )}
            </div>
        </div>
    );
};

export default PounceVoicemail;
